<template>
	<div
		v-if="loaded"
		class="sal-components-stock-quote-top"
	>
		<sal-components-eqsv-overview
			class="sal-components-eqsv-overview__wrapper sal-component"
			hide-chiclet
			hide-e-s-g
			hide-quote-header
			mwc-id="salEqsvOverview"
		/>

		<sal-components-eqsv-quote
			:trading-info-templates="tradingInfoTemplates"
			class="sal-components-eqsv-quote__wrapper sal-component"
			hide-chiclet
			mwc-id="salEqsvQuote"
			show-basic-content
		/>

		<sal-components-trailing-returns
			class="sal-components-trailing-returns__wrapper sal-component"
			hide-chiclet
			mwc-id="salTrailingReturns"
		/>
	</div>
</template>

<script>
import SalComponentsEqsvQuote from '@sal/eqsv-quote';
import SalComponentsEqsvOverview from '@sal/eqsv-overview';
import SalComponentsTrailingReturns from '@sal/trailing-returns';
import SalCommonMixin from '@/mixins/sal-common';

export default {
	name: 'quote-top',
	components: {
		SalComponentsEqsvOverview,
		SalComponentsEqsvQuote,
		SalComponentsTrailingReturns
	},
	mixins: [SalCommonMixin]
};
</script>
